
import AppCompanyInfo from "@/components/company/CompanyInfo.vue";
import AppCompanyInfoUsers from "@/components/company/CompanyInfoUsers.vue";
import AppCompanyInfoDossiers from "@/components/company/CompanyInfoDossiers.vue";
import AppCompanyInfoModules from "@/components/company/CompanyInfoModules.vue";
import AppCompanyInfoInvoices from "@/components/company/CompanyInfoInvoices.vue";
import AppCompanyInfoSubscriptions from "@/components/company/CompanyInfoSubscriptions.vue";
import AppCompanyInfoBilling from "@/components/company/CompanyInfoBilling.vue";
import AppCompanyInfoReferrals from "@/components/company/CompanyInfoReferrals.vue";
import { Company } from "@/models/company";
import { CompanyService } from "@/services/company-service";
import Vue from "vue";
import { setTitle, resetTitle } from "@/utils/title";

export default Vue.extend({
	data() {
		return {
			rawCompany: {},
			company: new Company(),
			currentTab: 0,
			ready: false
		};
	},
	watch: {
		company: {
			deep: true,
			async handler(newValue:Company, oldValue:Company){
				if (newValue != oldValue) return;
				await this.$nextTick();
				this.company = new Company(this.rawCompany);
			}
		},
		"$route.query.currentTab": {
			immediate: true,
			handler(){
				this.currentTab = parseInt(this.$route.query.currentTab as string || "0");
			}
		}
	},
	async mounted() {
		this.rawCompany = await CompanyService.getRawCompany(parseInt(this.$route.params.id));
		this.company = new Company(this.rawCompany);
		if (this.company.name) {
			setTitle(this.company.name);
		}
		this.ready = true;
	},
	async created(){
		//go to current tab if set and remove querry from url
		if (this.$route.query.currentTab) {
			this.currentTab = parseInt(this.$route.query.currentTab[0] || "0");
			let query = Object.assign({}, this.$route.query);
			delete query.currentTab;
			this.$router.replace({ query });
		}
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppCompanyInfo,
		AppCompanyInfoUsers,
		AppCompanyInfoDossiers,
		AppCompanyInfoModules,
		AppCompanyInfoInvoices,
		AppCompanyInfoSubscriptions,
		AppCompanyInfoBilling,
		AppCompanyInfoReferrals,
	}
});
